var scrollTop = 0;

$(function() {

  $(window).load(function() {
    var c_value = document.cookie;
    var c_start = c_value.indexOf(" scrollTop=");
    if (c_start == -1) {
      c_start = c_value.indexOf("scrollTop=");
    }

    if (c_start == -1) {
      c_value = null;
    }
    else {
      c_start = c_value.indexOf("=", c_start) + 1;
      var c_end = c_value.indexOf(";", c_start);
      if (c_end == -1) {
        c_end = c_value.length;
      }
      c_value = unescape(c_value.substring(c_start,c_end));
    }

    if (c_value != null) {
      $("html, body").scrollTop(c_value);
      saveScrollTopPosition(c_value);
    }
  }).scroll(function() {
    saveScrollTopPosition();
  });



  $("#products .product").hover(
    function() {
      if ($(this).find(".product_image_quick_view").length) {
        $(this).find(".product_image_featured").hide();
        $(this).find(".product_image_quick_view").show();

        $(this).find(".product_price").hide();
        $(this).find(".product_quick_view").show();
      }
    },
    function() {
      if ($(this).find(".product_image_quick_view").length) {
        $(this).find(".product_image_quick_view").hide();
        $(this).find(".product_image_featured").show();

        $(this).find(".product_quick_view").hide();
        $(this).find(".product_price").show();
      }
    }
  );
});

function saveScrollTopPosition() {
  scrollTop = $(window).scrollTop();

  var exdate = new Date();
  exdate.setDate(exdate.getDate() + 1);
  var c_value = escape(scrollTop) + "; expires=" + exdate.toUTCString();
  document.cookie = "scrollTop=" + c_value;
}
